import { chakra } from "@chakra-ui/react";

const Highlight = ({ children }) => {
    return (
        <chakra.span
            px={1.5}
            py={0.5}
            borderRadius="md"
            bg="brand.green.100"
            color="brand.blue.500"
            fontWeight="medium"
        >
            {children}
        </chakra.span>
    );
};

export default Highlight;
